export const HERO_BACKGROUND = Object.freeze({
  none: '',
  light: 'c-hero--bg-light',
  dark: 'c-hero--bg-dark'
})
